export function getMaxNumberInData<T>(data: Array<T>, type: string) {
  if (data?.length > 0) {
    return data
      .map((oldData) => oldData[type])
      .reduce((previousValue, currentValue) => {
        return previousValue > currentValue ? previousValue : currentValue;
      });
  }
}
